<template>
  <div>
    <page-loader v-if="loader" />
    <div
      v-else
      class="row"
    >
      <div class="col-20">
        <title-block
          :title="campaign.name"
        />
      </div>
      <status-bar
        :is-advertiser="isAdvertiser"
        :status="campaign.status"
        :member-status="memberStatus"
      />
      <div class="col-20">
        <campaign-info-bar
          :campaign="campaign"
          :advertiser="advertiser"
        />
      </div>
      <div class="col-20">
        <nav-buttons :campaign="campaign" />
      </div>
      <div class="col-20">
        <transition
          name="fade"
          @before-leave="makeAbsolute"
        >
          <router-view
            :campaign="campaign"
            :advertiser="advertiser"
          />
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import NavButtons from './details/NavButtons.vue'
import CampaignInfoBar from './common/CampaignInfoBar.vue'
import StatusBar from './common/StatusBar.vue'

export default {
  components: {
    'nav-buttons': NavButtons,
    'campaign-info-bar': CampaignInfoBar,
    'status-bar': StatusBar
  },
  data () {
    return {
      loader: true
    }
  },
  computed: {
    isAdvertiser () {
      return this.$store.state.user.profile.type === 'advertiser'
    },
    advertiser () {
      return this.$store.getters['advertisers/get'](this.campaign.advertiser_id)
    },
    campaign () {
      const campaignId = this.$route.params.id
      const campaign = this.isAdvertiser ? this.$store.getters['campaignsAdvertiser/getItem'](campaignId) : this.$store.getters['campaignsInfluencer/getItem'](campaignId)
      return campaign || { name: '', members: [], status: null }
    },
    memberStatus () {
      return this.isAdvertiser ? null : this.campaign.members.filter(member => member.influencer_id === this.$store.state.user.profileTypeData.id)[0].status
    }
  },
  created () {
    const campaignLoad = new Promise((resolve, reject) => {
      const campaignId = this.$route.params.id
      if (campaignId) {
        this.$store.dispatch(this.isAdvertiser ? 'campaignsAdvertiser/getOne' : 'campaignsInfluencer/getOne', campaignId)
          .then((result) => {
            if (this.$store.getters['advertisers/get'](result.advertiser_id)) {
              resolve()
            } else {
              this.$store.dispatch('advertisers/get', result.advertiser_id)
                .then(() => {
                  resolve()
                })
                .catch(() => {
                  this.$router.push({ name: 'campaigns' })
                })
            }
          })
          .catch(() => {
            this.$router.push({ name: 'campaigns' })
          })
      } else {
        this.$router.push({ name: 'campaigns' })
      }
    })

    Promise.all([
      campaignLoad
      // this.$store.dispatch('thematicCategories/get'),
      // this.$store.dispatch('channelsTypes/get')
    ]).then((values) => {
      this.loader = false
    })
  }
}
</script>
